import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import NotFoundView from "../views/NotFoundView";

class NotFoundController extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Fragment>
        <NotFoundView/>
      </Fragment>
    )
  }

}

export default withTranslation('local')(NotFoundController);
